<div
  class="send-nft-list-content"
  appInfiniteScroll
  [scrollThreshold]="70"
  (scrolled)="onScrolled($event)"
  (thresholdReached)="onThresholdReached()"
>
  <div class="nft-tokens-container flex column full-width gap-16">
    @if (loading()) {
      <!-- Skeleton loading states -->
      <div class="skeleton-loading-container flex column gap-16">
        @for (item of [1, 2, 3, 4, 5]; track item) {
          <app-skeleton
            class="full-width"
            [height]="'75px'"
            [width]="'auto'"
            [fullRound]="false"
          />
        }
      </div>
    } @else if (nfts().length === 0) {
      <!-- Empty state -->
      <div
        class="empty-state flex column align-items-center justify-content-center gap-16 p-32"
      >
        <div class="text-gray-60 typo-text-2 text-center">No NFTs found</div>
        <div class="text-gray-50 typo-text-1 text-center">
          You need to have NFTs in your wallet to send them.
        </div>
      </div>
    } @else {
      <!-- NFT list -->
      @for (nft of nfts(); track nft.tick + nft.tokenId) {
        <div
          class="nft-list-card card-0 card-hover flex full-width align-items-center justify-content-between p-16 fade-in"
          [class.cursor-pointer]="!isListed(nft)"
          [class.nft-list-card--disabled]="isListed(nft)"
          [attr.aria-disabled]="isListed(nft)"
          (click)="onNftClick(nft)"
        >
          <!-- NFT info section -->
          <div class="nft-card__info flex align-items-center gap-16">
            <div class="nft-card__image">
              @if (nft.isLoadingMetadata) {
                <app-skeleton
                  [height]="'48px'"
                  [width]="'48px'"
                  [fullRound]="false"
                />
              } @else if (getImageUrl(nft)) {
                <img
                  [src]="getImageUrl(nft)"
                  [alt]="getDisplayName(nft)"
                  (error)="onImageError($event)"
                  class="nft-image"
                />
              } @else {
                <div
                  class="nft-placeholder flex align-items-center justify-content-center"
                >
                  <span class="text-gray-40 typo-text-1">NFT</span>
                </div>
              }
            </div>
            <div class="flex column gap-4">
              @if (nft.isLoadingMetadata) {
                <app-skeleton
                  [height]="'20px'"
                  [width]="'120px'"
                  [fullRound]="false"
                />
                <app-skeleton
                  [height]="'16px'"
                  [width]="'80px'"
                  [fullRound]="false"
                />
              } @else {
                <div class="text-gray-90 typo-text-2">
                  {{ getDisplayName(nft) }}
                </div>
                <div class="text-gray-60 typo-text-1">
                  {{ nft.tick | uppercase }} #{{ nft.tokenId }}
                </div>
                @if (nft.description) {
                  <div class="text-gray-50 typo-text-1 nft-description">
                    {{
                      nft.description.length > 50
                        ? (nft.description | slice: 0 : 50) + "..."
                        : nft.description
                    }}
                  </div>
                }
              }
            </div>
          </div>
          <!-- Attributes section -->
          <div class="nft-card__attributes flex column align-items-end">
            @if (nft.isLoadingMetadata) {
              <app-skeleton
                [height]="'16px'"
                [width]="'60px'"
                [fullRound]="false"
              />
            } @else {
              @if (nft.attributes && nft.attributes.length > 0) {
                <div class="text-gray-90 typo-text-2">
                  {{ nft.attributes.length }} traits
                </div>
              }
            }
            <div class="text-gray-60 typo-text-1">
              {{ isListed(nft) ? "Cancel listing to send" : "Available" }}
            </div>
          </div>
        </div>
      }

      @if (isLoadingMore()) {
        <div
          class="loading-more-container flex justify-content-center p-16 full-width"
        >
          <app-skeleton
            class="full-width"
            [height]="'75px'"
            [width]="'auto'"
            [fullRound]="false"
          />
        </div>
      }
    }
  </div>
</div>
